import { Box, List, ListItem, Typography } from "@mui/material";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { useMediaQuery } from "@mui/material";
import color from "../../../../components/utils/Colors";
import SquareIcon from "@mui/icons-material/Square";
import { ChevronLeft } from "@mui/icons-material";

const Sidebar = () => {
  const location = useLocation();
  const isSmallScreen = useMediaQuery("(max-width:900px)");

  const navigate = useNavigate();
  const handleGoBack = () => {
    navigate(-1);
  };
  return (
    <Box
      sx={{
        width: isSmallScreen ? "100%" : "260px",
        boxShadow: "0",
        paddingTop: "2px",
        paddingBottom: "2%",
        background: "transparent",
        fontSize: "14px",
        borderTopLeftRadius: "10px",
        borderBottomLeftRadius: "10px",
      }}
    >
      <List
        sx={{
          display: "flex",
          flexDirection: isSmallScreen ? "row" : "column",
          flexWrap: isSmallScreen ? "wrap" : "nowrap",
          padding: 0,
          margin: 0,
          borderBottom: "none",
          borderRadius: "10px",
        }}
      >
        <Typography
          onClick={handleGoBack}
          sx={{
            margin: 0,
            color: color.firstColor,
            fontSize: "16px",
            fontWeight: "bold",
            paddingLeft: "2px",
            whiteSpace: "nowrap",
            display: "flex",
            alignItems: "center",
            cursor: "pointer",
          }}
        >
          <ChevronLeft></ChevronLeft> Back
        </Typography>
        <Box sx={{ backgroundColor: color.secondColor,
          display: "flex",
          flexDirection: isSmallScreen ? "row" : "column",
          flexWrap: isSmallScreen ? "wrap" : "nowrap",
          padding: 0,
          margin: 0,
          marginTop:2,
          borderBottom: "none",
          borderRadius: "10px",
          paddingBottom:4,
          border:'solid 1.5px',
          borderColor:color.borderColor
         }}>
          {[
            { Head: "Plan Your Course" },
            { text: "Course Description", path: "/course-desc" },
            { text: "Test Video", path: "/course-testVideo" },
            { Head: "Create Content" },
            { text: "Create content/modules", path: "/course-content" },
            { Head: "Publish Your Course" },
            {
              text: "Landing Page Content",
              path: "/course-landingPage",
            },
            { text: "Price your course", path: "/course-price" },
          ].map(({ Head, text, path }) =>
            path ? (
              <NavLink
                key={text}
                to={path}
                style={({ isActive }) => ({
                  textDecoration: "none",
                  color: isActive ? "#b365b6" : "inherit",
                  display: "flex",
                  alignItems: "center",
                  width: isSmallScreen ? "auto" : "100%",
                  flexGrow: isSmallScreen ? 1 : 0,
                  whiteSpace: "nowrap",
                  borderRadius: isSmallScreen ? "0px" : "8px",
                })}
              >
                <ListItem
                  button
                  sx={{
                    display: "flex",
                    alignItems: "flex-start",
                    flexDirection: "column",
                    flexWrap: "nowrap",
                    width: "100%",
                    marginRight: "10px",
                    marginLeft: "10px",
                    padding: 0,
                  }}
                >
                  {Head && (
                    <Typography
                      sx={{
                        margin: 0,
                        marginTop: "20px",
                        color: color.firstColor,
                        fontSize: "22px",
                        fontWeight: "bold",
                        padding: "8px",
                        paddingLeft: "2px",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {Head}
                    </Typography>
                  )}
                  <Typography
                    sx={{
                      margin: 0,
                      padding: "2px",
                      whiteSpace: "nowrap",
                      alignItems: "center",
                      justifyContent: "center",
                      display: "flex",
                      gap: "7px",
                      color: color.firstColor,
                    }}
                  >
                    <SquareIcon
                      sx={{
                        fontSize: "18px",
                        borderRadius: "4px",
                        color:
                          location.pathname === path
                            ? color.firstColor
                            : "transparent",
                        border: "solid 1px",
                        borderColor: color.firstColor,
                        // background:location.pathname === path ? color.firstColor:'transparent'
                      }}
                    ></SquareIcon>
                    {text}
                  </Typography>
                </ListItem>
              </NavLink>
            ) : (
              Head && (
                <ListItem
                  key={Head}
                  sx={{
                    display: "flex",
                    alignItems: "flex-start",
                    flexDirection: "column",
                    flexWrap: "nowrap",
                    width: "100%",
                    marginRight: "10px",
                    marginLeft: "10px",
                    padding: 0,
                  }}
                >
                  <Typography
                    sx={{
                      margin: 0,
                      marginTop: "20px",
                      color: color.firstColor,
                      fontSize: "22px",
                      fontWeight: "bold",
                      padding: "8px",
                      paddingLeft: "2px",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {Head}
                  </Typography>
                </ListItem>
              )
            )
          )}
        </Box>
      </List>
    </Box>
  );
};

export default Sidebar;
